<template>
  <slot v-if="hasPermissionSync && hasPermissionForCurrentMeeting"></slot>
  <div v-else>
    <div class="flex flex-col justify-center items-center h-full">
      <div class="flex justify-center items-center h-full">
        <sl-spinner style="font-size: 2rem" />
        Chargement du stage...
      </div>
      <sgdf-button style="margin-top: 2em" @click="goHome">
        <sgdf-icon slot="prefix" name="house"/>Retour à
        l'accueil</sgdf-button
      >
    </div>
  </div>
</template>
<script setup lang="ts">
import "@shoelace-style/shoelace/dist/components/button/button.js";
import "@shoelace-style/shoelace/dist/components/icon/icon.js";
import { extractPathname } from "~/core/configuration";

usePermission();
const meetingId = useMeetingId();

const store = useUserStore();
const { hasPermissionSync, hasMeetingPermissionSync } = storeToRefs(store);

const hasPermissionForCurrentMeeting = computed(() => {
  const meetingIdValue = meetingId.value;
  if (!meetingIdValue) {
    return true;
  }
  return hasMeetingPermissionSync.value(meetingIdValue);
});

const route = useRoute();

const goHome = async () => {
  const { query } = route;
  localStorage.removeItem("current_meeting");

  const destination = extractPathname(query.next as string);
  await navigateTo(destination);
};
</script>
